"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _qa = require("../../../utils/qa");
var _Icon = require("../../Icon");
var _StepperModule = _interopRequireDefault(require("../Stepper.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Type definitions for step content child props

const Step = exports.Step = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    active,
    children,
    completed = false,
    disabled = false,
    expanded = false,
    index = 0,
    last,
    classNames,
    onClick,
    allowClick,
    iconName,
    iconType,
    testId
  } = _ref;
  const childrenArray = React.Children.toArray(children).filter(Boolean);
  const stepContent = childrenArray.map(stepContent => {
    if (/*#__PURE__*/React.isValidElement(stepContent)) {
      return /*#__PURE__*/React.cloneElement(stepContent, {
        ...stepContent.props,
        active,
        completed,
        disabled,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'content'
        })
      });
    }
    return stepContent;
  });
  const handleClick = e => allowClick && onClick?.(index, e);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    className: (0, _classify.default)(_StepperModule.default.stepWrapper, {
      [_StepperModule.default.active]: active,
      [_StepperModule.default.completed]: completed,
      [_StepperModule.default.expanded]: expanded,
      [_StepperModule.default.last]: last,
      [_StepperModule.default.disabled]: disabled,
      [_StepperModule.default.clickable]: allowClick
    }, classNames?.wrapper),
    onClick: handleClick,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_StepperModule.default.stepWrapperCounter, {
        [_StepperModule.default.selected]: active,
        [_StepperModule.default.completed]: completed,
        [_StepperModule.default.expanded]: expanded,
        [_StepperModule.default.last]: last,
        [_StepperModule.default.disabled]: disabled,
        [_StepperModule.default.withIcon]: !!iconName
      }, classNames?.stepCounter),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'counter'
      }),
      children: completed && !active ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "check",
        type: _Icon.ICON_TYPE.solid,
        size: _Icon.ICON_SIZE.small,
        className: _StepperModule.default.stepIcon,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'check-icon'
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(React.Fragment, {
        children: iconName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: iconName,
          className: _StepperModule.default.stepIcon,
          size: _Icon.ICON_SIZE.small,
          type: iconType,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'icon'
          })
        }) : (index + 1).toString()
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_StepperModule.default.stepContent, classNames?.content),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'content'
      }),
      children: stepContent
    })]
  });
});